export default __webpack_public_path__ + "static/media/lose.26accda0.mp3";